import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight, Globe2, Car, MapPin } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";
import { ExternalNewsCard } from "@/components/ExternalNewsCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Column = ({ kind, icon: Icon, items }) => {
  const { t } = useLanguage();
  return (
    <div data-testid={`external-band-${kind}`}>
      <div className="mb-5 flex items-center justify-between">
        <h3 className="font-display inline-flex items-center gap-2 text-lg font-bold text-forest"><Icon className="h-5 w-5 text-gold" />{t.news.external[kind]}</h3>
        <Link to={`/actualites?tab=${kind}`} data-testid={`external-band-${kind}-more`} className="group inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-gold hover:text-gold-hover">{t.news.external.more}<ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></Link>
      </div>
      <div className="space-y-3">
        {items.length === 0 && <p className="rounded-2xl bg-white p-5 text-sm text-brand-hover">{t.news.external.empty}</p>}
        {items.map((it, i) => <ExternalNewsCard key={it.link} item={it} index={`${kind}-${i}`} compact />)}
      </div>
    </div>
  );
};

const ExternalNewsBand = () => {
  const { t } = useLanguage();
  const [data, setData] = useState({ ci: [], world: [], auto: [] });
  useEffect(() => {
    ["ci", "world", "auto"].forEach((k) => axios.get(`${API}/news/external?kind=${k}&limit=3`).then((r) => setData((d) => ({ ...d, [k]: r.data }))).catch(() => {}));
  }, []);

  return (
    <section className="py-20 sm:py-24" data-testid="external-news-band">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead overline={t.news.external.overline} title={t.news.external.title} accent={t.news.external.accent} />
        <Reveal delay={0.15}>
          <div className="mt-12 grid gap-10 lg:grid-cols-3">
            <Column kind="ci" icon={MapPin} items={data.ci} />
            <Column kind="world" icon={Globe2} items={data.world} />
            <Column kind="auto" icon={Car} items={data.auto} />
          </div>
          <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-brand/70">{t.news.external.updated}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default ExternalNewsBand;
